module.exports = __webpack_public_path__ + "img/karagandy2.0f1f493d.jpg";